import cat from '@/assets/cat.png';
import wow from '@/assets/wow.png';

export const NULL_SHEET = {
  songNo: 0,
  category: '???',
  title: 'ฅ•ω•ฅ',
  version: '?????',
  type: '??',
  difficulty: 'void',
  level: '0',
  levelValue: 0,
  bpm: 0,
  artist: ':3',
  noteDesigner: 'Oops! Nothing here :3',
  imageUrl: cat,
  searchUrl: 'https://www.youtube.com/watch?v=W1nifh1OhI8',
  memo: null,
};

export const UNKNOWN_SHEET = {
  songNo: 0,
  category: null,
  title: '？？？？？？？',
  version: null,
  type: '??',
  difficulty: 'unknown',
  level: '?',
  levelValue: 0,
  bpm: null,
  artist: null,
  noteDesigner: null,
  imageUrl: cat,
  searchUrl: null,
  memo: null,
};

export const SECRET_SHEET = {
  songNo: 0,
  category: 'Coin Master',
  title: 'Wow! Jennifer Lopez!',
  version: '?????',
  type: '??',
  difficulty: 'master',
  level: '🍍',
  levelValue: 999,
  bpm: 9999,
  artist: 'Shirley',
  noteDesigner: 'Did you just attack my village?',
  imageUrl: wow,
  searchUrl: 'https://www.youtube.com/watch?v=3CtTn9VQfjI',
  memo: null,
};
